import React from 'react';
import Alert from 'reactstrap/lib/Alert';

interface EntraIdErrorProps {
	errorMessage?: string;
}

/**
 * Basic component to display an error message for when an error occurs when trying to do an EntraId authentication
 */
export default function EntraIdError(props?: EntraIdErrorProps) {
	return (
		<Alert color="warning">
			<strong>
				An error occurred when trying to log you in using EntraId.
				<p />
				{props?.errorMessage ? (
					<>
						{props.errorMessage}
						<p />
					</>
				) : null}
			</strong>
			<a href="/login">Click here to try again.</a>
		</Alert>
	);
}

/**
 * Component to display the error message that EntraId is unavailable.
 */
export const EntraIdOffline = () => <EntraIdError errorMessage="Entra ID is currently unavailable." />;
